/**
 * Sales Agent Settings Service
 * The Sales Agent's Settings tab: the live chat disclaimer, the chat subtitle and the conversation
 * starters.
 *
 * Brand scoped by `?bu_id`, the write included: saving while a brand is selected saves that
 * brand's own settings, and saving with no brand saves the account's, which every brand without
 * its own reads.
 */

import { api } from '@/lib/api';
import { withBuScope } from '@/lib/business-unit-scope';
import { API_ENDPOINTS } from '@/constants/endpoints';
import type { ApiResponse } from '@/types';
import type { SalesAgentSettings, UpdateSalesAgentSettingsRequestDto } from '@/modules/sales-agent/settings/types';

type BuScope = { bu_id?: string };

export const salesAgentSettingsService = {
	async getSettings(scope: BuScope = {}): Promise<SalesAgentSettings> {
		const { data } = await api.get<ApiResponse<SalesAgentSettings>>(API_ENDPOINTS.SALES_AGENT.SETTINGS, {
			params: scope
		});
		return data.data;
	},

	/** Sent as given: the tab cleans the draft before saving. */
	async saveSettings(patch: UpdateSalesAgentSettingsRequestDto, scope: BuScope = {}): Promise<SalesAgentSettings> {
		const { data } = await api.put<ApiResponse<SalesAgentSettings>>(
			withBuScope(API_ENDPOINTS.SALES_AGENT.SETTINGS, scope),
			patch
		);
		return data.data;
	}
};
